import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SEOMeta from '@/components/base/SEOMeta';
import JsonLd from '@/components/base/JsonLd';
import HeroSection from '@/pages/home/components/HeroSection';
import FeaturedCategories from '@/pages/home/components/FeaturedCategories';
import LatestArticles from '@/pages/home/components/LatestArticles';
import FAQSection from '@/pages/home/components/FAQSection';
import { siteInfo } from '@/mocks/site';

export default function HomePage() {
  return (
    <>
      <ScrollToTop />
      <SEOMeta
        title="逼特逼视频-官方平台入口与内容指南"
        description={siteInfo.description}
        keywords={siteInfo.keywords}
      />
      <JsonLd type="Organization" />
      <JsonLd type="WebSite" />
      <JsonLd
        type="WebPage"
        pageTitle="逼特逼视频-官方平台入口与内容指南"
        pageDescription={siteInfo.description}
      />
      <JsonLd
        type="BreadcrumbList"
        breadcrumbs={[{ name: '首页', url: siteInfo.url }]}
      />

      <Navbar />

      <main>
        <HeroSection />
        <FeaturedCategories />
        <LatestArticles />

        <section className="py-14 md:py-20 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-10">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
                为什么选择逼特逼视频
              </h2>
              <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
                用心打造每一个细节，为您提供最优质的视频内容体验
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
              <div className="p-6 md:p-8 rounded-xl bg-background-50 border border-background-200/70">
                <div className="w-12 h-12 rounded-xl bg-accent-100 flex items-center justify-center mb-5">
                  <i className="ri-shield-check-line text-2xl text-accent-600"></i>
                </div>
                <h3 className="text-lg font-heading font-bold text-foreground-900 mb-2">内容安全保障</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  严格的内容审核机制，AI智能识别与人工复核相结合，确保平台内容安全可靠，为您营造清朗的网络空间。
                </p>
              </div>

              <div className="p-6 md:p-8 rounded-xl bg-background-50 border border-background-200/70">
                <div className="w-12 h-12 rounded-xl bg-secondary-100 flex items-center justify-center mb-5">
                  <i className="ri-speed-up-line text-2xl text-secondary-600"></i>
                </div>
                <h3 className="text-lg font-heading font-bold text-foreground-900 mb-2">极致流畅体验</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  全球CDN加速节点覆盖，智能码率自适应技术，无论您身处何地都能享受高清流畅的视频播放体验。
                </p>
              </div>

              <div className="p-6 md:p-8 rounded-xl bg-background-50 border border-background-200/70">
                <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center mb-5">
                  <i className="ri-user-heart-line text-2xl text-primary-600"></i>
                </div>
                <h3 className="text-lg font-heading font-bold text-foreground-900 mb-2">创作者扶持计划</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  丰厚的创作者激励政策，从流量扶持到商业变现，全力助力每一位有才华的内容创作者实现梦想。
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
              <div className="flex-1">
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-4">
                  随时随地，精彩随行
                </h2>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
                  逼特逼视频移动端APP专为移动场景优化，支持iOS和Android双平台。无论您是在通勤路上、排队等候还是休息时光，都能随时随地畅享海量优质视频内容。离线下载功能让您在没有网络的环境下也能观看已下载的视频。
                </p>
                <div className="flex flex-wrap gap-3">
                  <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-background-100 text-xs font-medium text-foreground-700">
                    <i className="ri-download-line"></i> 离线下载
                  </span>
                  <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-background-100 text-xs font-medium text-foreground-700">
                    <i className="ri-cast-line"></i> 投屏播放
                  </span>
                  <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-background-100 text-xs font-medium text-foreground-700">
                    <i className="ri-save-line"></i> 省流模式
                  </span>
                  <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-background-100 text-xs font-medium text-foreground-700">
                    <i className="ri-moon-line"></i> 夜间模式
                  </span>
                </div>
              </div>
              <div className="flex-1 flex justify-center">
                <div className="w-full max-w-sm h-80 rounded-2xl overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Smartphone%20mockup%20displaying%20modern%20video%20streaming%20app%20interface%20with%20clean%20minimalist%20design%2C%20warm%20coral%20accents%2C%20floating%20on%20clean%20cream%20background%2C%20product%20photography%20style%20with%20soft%20shadows&width=600&height=800&seq=home-mobile-mockup&orientation=squarish"
                    alt="逼特逼视频移动端APP"
                    className="w-full h-full object-cover object-top"
                    title="逼特逼视频移动端APP"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        <FAQSection />

        <section className="py-14 md:py-20 bg-primary-500">
          <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-4">
              准备好开始您的视频之旅了吗？
            </h2>
            <p className="text-sm md:text-base text-background-200 mb-8 max-w-xl mx-auto">
              立即加入逼特逼视频，探索海量精彩内容，发现属于您的视频世界
            </p>
            <a
              href="/category/entertainment"
              className="inline-flex items-center gap-2 px-8 py-3 rounded-full bg-background-50 text-primary-600 font-medium text-base whitespace-nowrap cursor-pointer hover:bg-background-100 transition-all duration-200"
            >
              <i className="ri-rocket-line"></i>
              开始探索
            </a>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}